// extracted by mini-css-extract-plugin
module.exports = {"ownerInformation":"OwnerInformation_ownerInformation__2f14D","ownerInformationTitle":"OwnerInformation_ownerInformationTitle__2pCmt","status":"OwnerInformation_status__BubzG"};